import { GATEWAY_URL, PAGE, PRODUCTS_NAMES, TYPES_PLANS } from "#/constants";
import { PreviousPage } from "../types";

export const HOME_PREVIOUS: PreviousPage = {
  name: "Home",
  to: GATEWAY_URL() + "/seguros/consulta",
};

export const MY_PLAN_PREVIOUS: (typePlan?: TYPES_PLANS) => PreviousPage = (
  typePlan: TYPES_PLANS | undefined
) => ({
  name: typePlan ? `Meu Plano ${PRODUCTS_NAMES[typePlan]}` : "Meu Plano",
  to: typePlan ? PAGE.MY_PLAN.ROOT() : PAGE.ROOT(),
});

export const DEPENDENTS_PREVIOUS: PreviousPage = {
  name: "Dependentes",
  to: PAGE.MY_PLAN.DEPENDENTS.ROOT(),
};
export const NEW_DEPENDENTS_PREVIOUS: PreviousPage = {
  name: "Novo Dependente",
  to: PAGE.MY_PLAN.DEPENDENTS.NEW(),
};

export const CONTRACT_PREVIOUS: PreviousPage = {
  name: "Dados do Cotrato",
  to: PAGE.MY_PLAN.CONTRACT_DATA.ROOT(),
};
